<template>
  <div>
    <h2 class="text-left alert alert-success">Client Details</h2>
    <dl class="dl-horizontal">
      <dt>Client Code</dt>
      <dd>{{ model.client_code || '-' }}</dd>

      <dt>Company</dt>
      <dd>{{ model.company || '-' }}</dd>

      <dt>Name</dt>
      <dd>{{ model.full_name || '-' }}</dd>

      <dt>Farm Group Name</dt>
      <dd>{{ model.farm_group_name || '-' }}</dd>

      <dt>Last Winter Consult Year</dt>
      <dd>{{ model.previous_winter_consult_year || '-' }}</dd>

      <dt>Zone</dt>
      <dd>{{ model.zone || '-' }}</dd>

      <dt>Address</dt>
      <dd>{{ model.full_address || '-' }}</dd>

      <dt>Phone</dt>
      <dd>{{ model.phone || '-' }}</dd>

      <dt>Mobile</dt>
      <dd>{{ model.mobile || '-' }}</dd>

      <dt>E-Mail</dt>
      <dd>{{ model.email || '-' }}</dd>
    </dl>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'ClientDetails',
  mixins: [mixin],
}
</script>
